/**
 * Shared option lists + colour maps for Dev Tickets.
 * `label` doubles as the i18n key (flat English-keyed locale files), so feed it
 * through msg() in templates. `variant` is a Bootstrap-Vue contextual variant.
 * Enum values MUST match the backend enums exactly.
 */

export const DEV_TICKET_TYPES = [
    {value: 'NEW_FEATURE', label: 'New feature', variant: 'primary', icon: 'StarIcon'},
    {value: 'BUG', label: 'Bug', variant: 'danger', icon: 'AlertTriangleIcon'},
    {value: 'CLAIM', label: 'Claim', variant: 'warning', icon: 'FlagIcon'},
    {value: 'TASK', label: 'Task', variant: 'info', icon: 'CheckSquareIcon'},
];

export const DEV_TICKET_STATUSES = [
    {value: 'REQUEST', label: 'Request', variant: 'secondary'},
    {value: 'IN_PROGRESS', label: 'In progress', variant: 'primary'},
    {value: 'WAITING_FOR_USER_RESPONSE', label: 'Waiting for client response', variant: 'warning'},
    {value: 'DONE', label: 'Done', variant: 'success'},
    {value: 'CANCELLED', label: 'Cancelled', variant: 'dark'},
    {value: 'DUPLICATED', label: 'Duplicated', variant: 'secondary'},
];

export const DEV_TICKET_PRIORITIES = [
    {value: 'LOW', label: 'Low', variant: 'secondary'},
    {value: 'MEDIUM', label: 'Medium', variant: 'info'},
    {value: 'HIGH', label: 'High', variant: 'warning'},
    {value: 'CRITICAL', label: 'Critical', variant: 'danger'},
];

export const DEV_TICKET_MODULES = [
    {value: 'DASHBOARD', label: 'Dashboard'},
    {value: 'REAL_ESTATE', label: 'Real estate'},
    {value: 'CONTRACTS', label: 'Contracts'},
    {value: 'RESERVATIONS', label: 'Reservations'},
    {value: 'CLEANING', label: 'Cleaning'},
    {value: 'CLIENTS', label: 'Clients'},
    {value: 'KEYBOX', label: 'Keybox'},
    {value: 'CATALOG', label: 'Catalog'},
    {value: 'INVOICES', label: 'Invoices'},
    {value: 'RECEPTION', label: 'Reception'},
    {value: 'CHANNEL_MANAGER', label: 'Channel manager'},
    {value: 'BRANCHES', label: 'Branches'},
    {value: 'USERS', label: 'Users'},
    {value: 'PERMISSIONS', label: 'Permissions'},
    {value: 'REPORTS', label: 'Reports'},
    {value: 'NOTIFICATIONS', label: 'Notifications'},
    {value: 'MOBILE_APP', label: 'Mobile app'},
    {value: 'WEBSITE', label: 'Website'},
    {value: 'OTHER', label: 'Other'},
];

function lookup(list, value) {
    return list.find((o) => o.value === value) || null;
}

export function typeMeta(value) { return lookup(DEV_TICKET_TYPES, value); }
export function statusMeta(value) { return lookup(DEV_TICKET_STATUSES, value); }
export function priorityMeta(value) { return lookup(DEV_TICKET_PRIORITIES, value); }
export function moduleMeta(value) { return lookup(DEV_TICKET_MODULES, value); }

export function labelFor(list, value) {
    const m = lookup(list, value);
    return m ? m.label : (value || '');
}

export function variantFor(list, value) {
    const m = lookup(list, value);
    return m ? m.variant : 'secondary';
}
